const lbaTextArea = angular.module('app.lbaTextArea', []);

lbaTextArea.controller('lbaTextAreaCtrl', require('./lbaTextAreaCtrl'));
lbaTextArea.directive('lbaTextArea', require('./lbaTextAreaDir'));

export default lbaTextArea;



// WEBPACK FOOTER //
// ./src/components/lbaTextArea/index.js